// RegisterPage.js - 响应式注册页面
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";

const RegisterPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRegister = (e) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords don't match!");
      return;
    }
    console.log("Register:", formData);
    navigate("/");
  };

  return (
    <>
      <style>{`
        .register-container {
          min-height: 100vh;
          display: flex;
          background: white;
        }
        
        /* 左侧背景部分 - 50% */
        .register-left {
          flex: 1;
          background: linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)),
                      url('https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1600') center/cover;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 60px;
          color: white;
          position: relative;
        }
        
        .register-logo {
          display: flex;
          align-items: center;
          gap: 12px;
          position: absolute;
          top: 40px;
          left: 40px;
        }

        .register-logo a {
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  gap: 8px; 
}

.register-logo a:hover {
  color: #0077ff;          
  transform: scale(1.05);  
}
        
        .register-logo img {
          width: 40px;
          height: 40px;
          border-radius: 8px;
        }
        
        .register-logo span {
          font-size: 20px;
          font-weight: 600;
          color: white;
        }
        
        .register-welcome {
          max-width: 500px;
        }
        
        .register-title {
          font-size: 48px;
          font-weight: 300;
          margin-bottom: 8px;
          line-height: 1.2;
        }
        
        .register-highlight {
          font-size: 48px;
          font-weight: 600;
          color: #FFA500;
          margin-bottom: 24px;
        }
        
        .register-desc {
          font-size: 18px;
          line-height: 1.6;
          opacity: 0.95;
        }
        
        .footer-copyright {
          position: absolute;
          bottom: 40px;
          left: 40px;
          font-size: 13px;
          opacity: 0.8;
        }
        
        /* 右侧表单部分 - 50% */
        .register-right {
          flex: 1;
          background: white;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px;
          overflow-y: auto;
        }
        
        .register-form-container {
          width: 100%;
          max-width: 420px;
        }
        
        .form-logo {
          width: 48px;
          height: 48px;
          margin: 0 auto 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f7;
          border-radius: 12px;
        }
        
        .form-logo img {
          width: 32px;
          height: 32px;
        }
        
        .mobile-brand {
          display: none;
          text-align: center;
          font-size: 20px;
          font-weight: 600;
          color: #1a1a1a;
          margin-bottom: 24px;
        }
        
        .form-title {
          font-size: 32px;
          font-weight: 600;
          text-align: center;
          margin-bottom: 8px;
          color: #1a1a1a;
        }
        
        .form-subtitle {
          text-align: center;
          color: #6b7280;
          margin-bottom: 32px;
        }
        
        .form-group {
          margin-bottom: 20px;
        }
        
        .form-label {
          font-size: 14px;
          font-weight: 500;
          color: #374151;
          margin-bottom: 8px;
          display: block;
        }
        
        .form-input-wrapper {
          position: relative;
        }
        
        .form-input {
          width: 100%;
          padding: 12px 16px;
          padding-left: 40px;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          font-size: 15px;
          transition: all 0.3s;
        }
        
        .form-input.password-input {
          padding-right: 40px;
        }
        
        .form-input:focus {
          outline: none;
          border-color: #1b2a41;
          box-shadow: 0 0 0 3px rgba(27, 42, 65, 0.1);
        }
        
        .input-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: #9ca3af;
          font-size: 18px;
        }
        
        .password-toggle {
          position: absolute;
          right: 12px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #9ca3af;
          cursor: pointer;
          padding: 4px;
          font-size: 18px;
        }
        
        .password-toggle:hover {
          color: #6b7280;
        }
        
        .register-btn {
          width: 100%;
          padding: 12px;
          background: #1b2a41;
          color: white;
          border: none;
          border-radius: 8px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 24px;
        }
        
        .register-btn:hover {
          background: #2a3a51;
          transform: translateY(-1px);
        }
        
        .divider {
          text-align: center;
          margin: 32px 0;
          position: relative;
          color: #9ca3af;
          font-size: 14px;
        }
        
        .divider::before,
        .divider::after {
          content: '';
          position: absolute;
          top: 50%;
          width: calc(50% - 60px);
          height: 1px;
          background: #e5e7eb;
        }
        
        .divider::before {
          left: 0;
        }
        
        .divider::after {
          right: 0;
        }
        
        .social-buttons {
          display: flex;
          gap: 12px;
        }
        
        .social-btn {
          flex: 1;
          padding: 10px;
          background: white;
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          cursor: pointer;
          transition: all 0.3s;
          font-size: 14px;
          color: #374151;
        }
        
        .social-btn:hover {
          background: #f9fafb;
          border-color: #d1d5db;
        }
        
        .social-btn i {
          font-size: 18px;
        }
        
        .bi-google { color: #4285F4; }
        .bi-facebook { color: #1877F2; }
        
        .signin-link {
          text-align: center;
          margin-top: 32px;
          color: #6b7280;
          font-size: 14px;
        }
        
        .signin-link a {
          color: #1b2a41;
          text-decoration: none;
          font-weight: 500;
        }
        
        .signin-link a:hover {
          text-decoration: underline;
        }
        
        .terms-text {
          text-align: center;
          margin-top: 24px;
          font-size: 12px;
          color: #9ca3af;
          line-height: 1.5;
        }
        
        .terms-text a {
          color: #6b7280;
          text-decoration: none;
        }
        
        .terms-text a:hover {
          text-decoration: underline;
        }
        
        .mobile-footer {
          display: none;
        }
        
        /* 平板响应式 */
        @media (max-width: 1200px) {
          .register-left {
            flex: 0.8;
          }
          
          .register-right {
            flex: 1.2;
            padding: 40px;
          }
        }
        
        @media (max-width: 1024px) {
          .register-left {
            display: none;
          }
          
          .register-right {
            width: 100%;
            min-height: 100vh;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 40px;
          }
          
          .register-form-container {
            background: white;
            padding: 40px;
            border-radius: 24px;
            box-shadow: 0 20px 60px rgba(0,0,0,0.1);
            max-width: 480px;
          }
        }
        
        /* 移动端响应式 */
        @media (max-width: 640px) {
          .register-container {
            background: #f5f5f7;
          }
          
          .register-right {
            padding: 20px;
            background: #f5f5f7;
          }
          
          .register-form-container {
            background: white;
            padding: 32px 24px;
            border-radius: 24px 24px 0 0;
            margin-top: 20px;
            box-shadow: none;
          }
          
          .form-logo {
            width: 56px;
            height: 56px;
            margin-bottom: 16px;
          }
          
          .form-logo img {
            width: 36px;
            height: 36px;
          }
          
          .mobile-brand {
            display: block;
          }
          
          .form-title {
            font-size: 28px;
          }
          
          .form-subtitle {
            font-size: 15px;
            margin-bottom: 24px;
          }
          
          .register-btn {
            padding: 14px;
            font-size: 16px;
            border-radius: 12px;
          }
          
          .social-btn {
            padding: 12px 8px;
            border-radius: 12px;
            font-size: 13px;
          }
          
          .social-btn span {
            display: none;
          }
          
          .mobile-footer {
            display: block;
            text-align: center;
            padding: 20px;
            background: white;
            color: #6b7280;
            font-size: 13px;
          }
          
          .mobile-footer-links {
            display: flex;
            justify-content: center;
            gap: 20px;
            margin-top: 8px;
          }
          
          .mobile-footer-links a {
            color: #6b7280;
            text-decoration: none;
          }
        }
      `}</style>

      <div className="register-container">
        {/* 左侧背景 - 桌面端显示 */}
        <div className="register-left">
          <div className="register-logo">
            <Link to={"/"}>
              <img src="/assets/logocity.jpg" alt="CityGetAway" />
              <span>CityGetAway</span>
            </Link>
          </div>

          <div className="register-welcome">
            <div className="register-title">Your next adventure</div>
            <div className="register-highlight">starts here</div>
            <p className="register-desc">
              Join thousands of travelers discovering worry-free, AI-powered
              city explorations around the world.
            </p>
          </div>

          <div className="footer-copyright">
            © 2025 CityGetAway. All rights reserved.
          </div>
        </div>

        {/* 右侧注册表单 */}
        <div className="register-right">
          <div className="register-form-container">
            <div className="form-logo">
              <img src="/assets/logocity.jpg" alt="Logo" />
            </div>

            <div className="mobile-brand">CityGetAway</div>

            <h1 className="form-title">Create your account</h1>
            <p className="form-subtitle">
              Start your worry-free, AI-powered travel journey
            </p>

            <form onSubmit={handleRegister}>
              <div className="form-group">
                <label className="form-label">Full Name</label>
                <div className="form-input-wrapper">
                  <i className="bi bi-person input-icon"></i>
                  <input
                    type="text"
                    name="fullName"
                    className="form-input"
                    placeholder="John Doe"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Email</label>
                <div className="form-input-wrapper">
                  <i className="bi bi-envelope input-icon"></i>
                  <input
                    type="email"
                    name="email"
                    className="form-input"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Password</label>
                <div className="form-input-wrapper">
                  <i className="bi bi-lock input-icon"></i>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="form-input password-input"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    <i
                      className={`bi bi-eye${showPassword ? "-slash" : ""}`}
                    ></i>
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <div className="form-input-wrapper">
                  <i className="bi bi-lock input-icon"></i>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    className="form-input password-input"
                    placeholder="••••••••"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    <i
                      className={`bi bi-eye${
                        showConfirmPassword ? "-slash" : ""
                      }`}
                    ></i>
                  </button>
                </div>
              </div>

              <button type="submit" className="register-btn">
                Create Account
              </button>
            </form>

            <div className="divider">Or continue with</div>

            <div className="social-buttons">
              <button className="social-btn">
                <i className="bi bi-google"></i>
                <span>Google</span>
              </button>
              <button className="social-btn">
                <i className="bi bi-facebook"></i>
                <span>Facebook</span>
              </button>
            </div>

            <div className="signin-link">
              Already have an account?{" "}
              <a onClick={() => navigate("/login")}>Sign in</a>
            </div>

            <div className="terms-text">
              By continuing, you agree to our{" "}
              <a href="/privacy">Privacy Policy</a>
              <br />& <a href="/terms">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>

      {/* 移动端底部 */}
      <div className="mobile-footer">
        <div>© 2025 CityGetAway. All rights reserved.</div>
        <div className="mobile-footer-links">
          <a href="/privacy">Privacy</a>
          <a href="/terms">Terms</a>
          <a href="/contact">Contact</a>
        </div>
      </div>
    </>
  );
};

export default RegisterPage;
